module.exports = __webpack_public_path__ + "img/aboutzhuxue.c254faac.jpg";